import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HEADERS } from 'src/app/constants/services-headers';

import { environment } from "src/environments/environment";

@Injectable({ providedIn: 'root' })
export class ReportsService {

  constructor(private http: HttpClient) { }

  /* request(): Método común que solicita información al api de indicadores de red de acuerdo a los parámetros recibidos
    data: Parámetros recibidos desde cada componente
    nameMethod: Método que se ejecutará en el controlador del api
  */
  request = (data: FormData, nameMethod: string): Observable<any> => this.http.post(environment.apiPath + "ApiReports/" + nameMethod, data, HEADERS);

  // saveMRPReport(): Servicio para guardar PDF generado
  saveMRPReport = (data: FormData, nameMethod: string): Observable<any> => this.request(data, nameMethod);

  // getPAEReport(): Servicio para obtener información de Entidades por Cconvenio
  getPAEReport = (data: FormData, nameMethod: string): Observable<any> => this.request(data, nameMethod);

  // getPAEReport(): Servicio para obtener información de Gestión y Recuperaciones
  getMRPReport = (data: FormData, nameMethod: string): Observable<any> => this.request(data, nameMethod);

  // getMADReport(): Servicio para obtener información de Movilizado y Desembolsos
  getMADReport = (data: FormData, nameMethod: string): Observable<any> => this.request(data, nameMethod);

  // getCUPReport(): Servicio para obtener información de Rendimiento Unidad Cobertura
  getCUPReport = (data: FormData, nameMethod: string): Observable<any> => this.request(data, nameMethod);

  // getCAOReport(): Servicio para obtener información de reclamaciones
  getCAOReport = (data: FormData, nameMethod: string): Observable<any> => this.request(data, nameMethod);

  // getMGReport(): Servicio para obtener información de Crecimiento Movilizado
  getMGReport = (data: FormData, nameMethod: string): Observable<any> => this.request(data, nameMethod);

}
